'use strict';

var mcsclient = require('./client');
module.exports = mcsclient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/twilio-mcs-client/browser/index.js
// module id = ./node_modules/twilio-mcs-client/browser/index.js
// module chunks = 0